import * as React from 'react';

import { IRegionalAndLanguageSettingsQueryResult } from '../../Language/hooks/useGetRegionalAndLanguageSettingQuery';
import { PdfDocument } from './PdfDocument';

export interface IPdfViewerProps {
  readonly pdfData: Uint8Array;
  readonly getRegionalAndLanguageSettingsQuery?: IRegionalAndLanguageSettingsQueryResult;
}

export const PdfViewer: React.FC<IPdfViewerProps> = ({ pdfData, getRegionalAndLanguageSettingsQuery }) => {
  return <PdfDocument file={pdfData} getRegionalAndLanguageSettingsQuery={getRegionalAndLanguageSettingsQuery} />;
};
